/**
 * Shared drag handle — six-dot vertical "grip" icon used in
 * Brainstorm and Design Template chunk + bit rows.
 *
 * The actual drag listeners come from useSortable in the parent;
 * this component just spreads them onto a button so only the handle
 * (not the whole row) initiates a drag.
 */
export default function DragHandle({ listeners, attributes, label = 'Drag to reorder', className = '' }) {
  return (
    <button
      type="button"
      className={`drag-handle ${className}`}
      aria-label={label}
      title={label}
      {...listeners}
      {...attributes}
    >
      <svg width="14" height="20" viewBox="0 0 14 20" aria-hidden="true">
        <circle cx="4"  cy="4"  r="1.4" fill="currentColor" />
        <circle cx="10" cy="4"  r="1.4" fill="currentColor" />
        <circle cx="4"  cy="10" r="1.4" fill="currentColor" />
        <circle cx="10" cy="10" r="1.4" fill="currentColor" />
        <circle cx="4"  cy="16" r="1.4" fill="currentColor" />
        <circle cx="10" cy="16" r="1.4" fill="currentColor" />
      </svg>
    </button>
  );
}
